import React, { useState, useEffect, useRef } from 'react';
import services from '../../services';

const PROPERTY_TYPES = [
    { value: 'Status', icon: '▶️' },
    { value: 'Tag', icon: '🏷️' },
];

const PropertySettingsModal = ({
    show,
    onClose,
    onSave,
    selectedBoardId,
    className = '',
    getPropertyByID,
    setShowPropertyModal,
    selectedColumnField,
    onDelete,
    position = { top: 0, left: 0 },
}) => {
    const [type, setType] = useState('');
    const [name, setName] = useState('');
    const [displayOnCard, setDisplayOnCard] = useState(false);
    const [propertyId, setPropertyId] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        }
        if (show) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show, onClose]);

    useEffect(() => {
        if (show && selectedColumnField?.property) {
            const { name: typeName, propertyName } = selectedColumnField.property;
            setType(typeName || '');
            setName(propertyName || '');
            setDisplayOnCard(false);
            setPropertyId(selectedColumnField.id);
        }
    }, [show, selectedColumnField]);

    if (!show) return null;

    const handleSave = async () => {
        try {
            const propertyType = PROPERTY_TYPES.find((opt) => opt.value === type);
            const isUpdate = !!propertyId;
            const data = {
                property: {
                    name: propertyType?.value,
                    icon: propertyType?.icon,
                    value: null,
                    propertyName: name,
                },
                boardId: selectedBoardId,
                isVisible: displayOnCard,
            };
            if (isUpdate) {
                await services?.property?.UPDATE_PROPERTY(propertyId, data);
            } else {
                await services?.property?.CREATE_PROPERTY(data);
            }
            getPropertyByID(selectedBoardId);
            setDisplayOnCard(false);
            setShowPropertyModal(false);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    return (
        <div ref={modalRef} className={`psm-wrap ${className}`}>
            <div className="psm-header">
                <span className="psm-title">Property Settings</span>
                <div className="psm-header-icons">
                    <button
                        className="psm-delete-btn"
                        title="Delete Property"
                        onClick={() => {
                            if (selectedColumnField && selectedColumnField.id) {
                                onDelete?.(selectedColumnField.id);
                            }
                            setShowPropertyModal(false);
                        }}
                    >
                        <i className="bi bi-trash" />
                    </button>
                </div>
            </div>

            <div className="psm-divider" />

            <div className="psm-field">
                <label className="psm-label">Type</label>
                <select
                    className="psm-select"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                >
                    <option value="">Select type</option>
                    {PROPERTY_TYPES.map((item, idx) => (
                        <option key={idx} value={item.value}>
                            {item.icon} {item.value}
                        </option>
                    ))}
                </select>
            </div>

            <div className="psm-field">
                <label className="psm-label">Property Name</label>
                <input
                    type="text"
                    className="psm-input"
                    placeholder="Add property name here"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>

            <div className="psm-checkbox-row">
                <input
                    type="checkbox"
                    id="displayOnCard"
                    className="psm-checkbox"
                    checked={displayOnCard}
                    onChange={(e) => setDisplayOnCard(e.target.checked)}
                />
                <label htmlFor="displayOnCard" className="psm-checkbox-label">
                    Display on Card <span>(available on tags + statuses)</span>
                </label>
            </div>

            <div className="psm-actions">
                <button className="psm-btn-cancel" onClick={onClose}>
                    Cancel
                </button>
                <button
                    className="psm-btn-save"
                    onClick={handleSave}
                    disabled={!type || !name}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default PropertySettingsModal;
